import React from "react";
import { List, ListItem, Checkbox, FormControlLabel } from "@mui/material";
import { GridColDef, GridColumnVisibilityModel } from "@mui/x-data-grid";

type ColumnsManagementProps = {
  columnsVisibility: GridColumnVisibilityModel;
  onChange: (columnName: string, isVisible: boolean) => void;
  columns: GridColDef[];
};

export const ColumnsManagement = ({
  columnsVisibility,
  columns,
  onChange,
}: ColumnsManagementProps) => {
  return (
    <List dense>
      {columns.map(({ headerName, field }) => (
        <ListItem sx={{ p: "0.8rem" }} key={field}>
          <FormControlLabel
            sx={{
              alignItems: "center",
              fontSize: 12,
            }}
            control={
              <Checkbox
                checked={columnsVisibility[field]}
                onChange={(event) => onChange(field, event.target.checked)}
              />
            }
            label={headerName}
          />
        </ListItem>
      ))}
    </List>
  );
};
